"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectList = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var ProjectList = function (props) {
    return (React.createElement("div", { className: props.className },
        props.status.isBusy && (React.createElement("div", { className: 'loading-spinner-container' },
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        props.status.isSuccess && React.createElement("div", { className: 'list' }, props.children)));
};
exports.ProjectList = ProjectList;
